import { motion } from "framer-motion";
import { ArrowUpRight, ShoppingBag } from "lucide-react";
import { PRODUCTS, FEATURED_IDS } from "@/data/products";
import { SITE } from "@/data/site";

export const FeaturedProducts = () => {
  const featured = FEATURED_IDS
    .map((id) => PRODUCTS.find((p) => p.id === id))
    .filter(Boolean);

  return (
    <section id="urunler" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <span className="eyebrow">Vitrin</span>
            <h2 className="font-display text-4xl lg:text-5xl mt-3 text-[hsl(var(--nl-anthracite))]">
              Öne Çıkan <em className="not-italic font-serif italic gold-text">Ürünler</em>
            </h2>
            <div className="gold-line mt-5" />
          </div>
          <p className="max-w-md text-sm text-[hsl(var(--muted-foreground))] leading-relaxed">
            Ürüne tıklayarak Shopier mağazamızdan güvenle sipariş verebilirsiniz.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-7">
          {featured.map((p, i) => (
            <motion.a
              key={p.id}
              data-testid={`product-card-${p.id}`}
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.05 * i }}
              className="product-card group block"
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-[hsl(var(--nl-beige))]">
                <img
                  src={p.image}
                  alt={p.name}
                  className="product-img w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 bg-white/90 backdrop-blur px-2.5 py-1 text-[10px] tracking-[0.2em] uppercase gold-text">
                  Shopier
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--nl-anthracite)/0.45)] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute bottom-3 right-3 w-9 h-9 rounded-full bg-[hsl(var(--nl-champagne))] text-[hsl(var(--nl-anthracite))] grid place-items-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                  <ArrowUpRight size={16} />
                </div>
              </div>
              <div className="p-4 lg:p-5">
                <h3 className="font-serif text-base lg:text-lg text-[hsl(var(--nl-anthracite))] leading-tight line-clamp-2 min-h-[2.6rem]">
                  {p.name}
                </h3>
                <div className="mt-3 pt-3 border-t border-[hsl(var(--nl-line))] flex items-center justify-between gap-2">
                  {p.price ? (
                    <span className="font-display text-lg gold-text">{p.price}</span>
                  ) : (
                    <span className="text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--muted-foreground))]">Detay için tıkla</span>
                  )}
                  <span className="text-[10px] uppercase tracking-[0.18em] gold-text group-hover:text-[hsl(var(--nl-anthracite))] transition-colors">
                    Satın Al →
                  </span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-16 lg:mt-20 relative overflow-hidden bg-[hsl(var(--nl-anthracite))] text-[hsl(var(--nl-cream))] p-8 lg:p-12"
          data-testid="shopier-banner"
        >
          <div className="absolute -right-16 -top-16 w-72 h-72 rounded-full bg-[hsl(var(--nl-champagne)/0.15)] blur-3xl pointer-events-none" />
          <div className="absolute -left-10 -bottom-10 w-56 h-56 rounded-full bg-[hsl(var(--nl-champagne)/0.08)] blur-2xl pointer-events-none" />
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-8">
            <div className="max-w-xl">
              <span className="eyebrow !text-[hsl(var(--nl-champagne))]">Online Mağaza</span>
              <h3 className="font-display text-3xl lg:text-4xl mt-3 leading-tight">
                Tüm {PRODUCTS.length}+ koleksiyon <em className="not-italic font-serif italic gold-text">Shopier&apos;de</em>
              </h3>
              <p className="text-sm text-[hsl(var(--nl-cream))]/70 mt-4 leading-relaxed">
                Güvenli ödeme, hızlı kargo. Tüm parçalarımızı Shopier mağazamızdan
                inceleyebilir ve satın alabilirsiniz.
              </p>
            </div>
            <a
              data-testid="featured-shopier-cta"
              href={SITE.social.shopier}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-7 py-4 bg-[hsl(var(--nl-champagne))] text-[hsl(var(--nl-anthracite))] text-xs uppercase tracking-[0.2em] font-semibold hover:bg-[hsl(var(--nl-cream))] transition-colors shrink-0"
            >
              <ShoppingBag size={16} /> Shopier Mağazaya Git
              <ArrowUpRight size={14} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
